import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef , MAT_DIALOG_DATA  } from '@angular/material/dialog';
import { Observable} from 'rxjs';
import { map } from 'rxjs/operators';
import { Constants } from '../constants';

@Component({
    selector: 'app-obsolete-browser-banner',
    templateUrl: './obsolete-browser-banner.component.html',
    styleUrls: ['./obsolete-browser-banner.component.scss'],
    standalone: false
})
export class ObsoleteBrowserBannerComponent implements OnInit {
  public browserName = '';
  isScreenSmall: Observable<boolean>;

  constructor(public dialogRef: MatDialogRef<ObsoleteBrowserBannerComponent>,
              @Inject(MAT_DIALOG_DATA) private data: any,
              breakpoints: BreakpointObserver) {
                this.isScreenSmall = breakpoints.observe(`(max-width: ${Constants.OBSOLETE_BANNER_BREAKPOINT}px)`)
                  .pipe(map(breakpoint => breakpoint.matches));
  }

  ngOnInit() {
    this.browserName = `${this.data.BrowserName}​​​${(this.data.BrowserName === 'IE 11') ? '' : this.data.Version}​​​`;
  }

  CloseDialog() {
    const self = this;
    self.dialogRef.close(false);
  }
}
